import firebase from "firebase/app";
import "firebase/database";
import firebaseConfig from "./Config";

firebase.initializeApp(firebaseConfig);